import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import MuiDatepicker from "app/pages/Docgen/components/common/mui-datepicker/MuiDatepicker";
import moment from "moment";
import {useEffect, useState} from "react";
import {Date_format} from "../../../constants/date_format";

const FormSearchFilter = ({options, dateFiltersOptionsValueArray, dropdownArray, dropdownOptions, defaultOption, onSearch, searchResetKey=0}) => {
    const [child_selectedFilterDdl, child_setSelectedFilterDdl] = useState(""); // selected filter dropdown value
    const [child_startDate, child_setStartDate] = useState(null);
    const [child_endDate, child_setEndDate] = useState(null);
    const [child_searchedText, child_setSearchedText] = useState("");
    const [child_dropdownValue, child_setDropdownValue] = useState(defaultOption?.value || "");
    const [onClose1, setOnClose1] = useState(false);

    useEffect(() => {
        child_setStartDate(null);
        child_setEndDate(null);
        child_setSearchedText("");
    }, [searchResetKey]);
    
    useEffect(() => {
        child_setStartDate(null);
        child_setEndDate(null);
        child_setSearchedText("");
        if (dropdownArray?.includes(child_selectedFilterDdl)) {
            child_setDropdownValue(""); // Default to "Select an option"
        }
        handleSearch({
            value: "",
            startDate: "",
            endDate: "",
            searchedText: "",
            dropdownValue: ""
        });
    }, [child_selectedFilterDdl]);

    useEffect(() => {
        handleSearch();
    }, [child_dropdownValue]);

    const resetSearch = () => {
        child_setSearchedText("");
        onSearch({
            value: "",
            startDate: "",
            endDate: "",
            searchedText: "",
            dropdownValue: ""
        });
    };

    const handleSearch = (override = {}) => {
        const value = override.value ?? child_selectedFilterDdl;
        const start = override.startDate ?? child_startDate;
        const end = override.endDate ?? child_endDate;
        const text = override.searchedText ?? child_searchedText;
        const ddl = override.dropdownValue ?? child_dropdownValue;

        const formattedStart = start ? start.format(Date_format.date_format_search) : null;
        const formattedEnd = end ? end.format(Date_format.date_format_search) : null;
        onSearch({
            value,
            startDate: formattedStart,
            endDate: formattedEnd,
            searchedText: text,
            dropdownValue: ddl
        });
    };

    return (
        <div className="customize-table-search">
            <select className="select-column" value={child_selectedFilterDdl} onChange={(e) => child_setSelectedFilterDdl(e.target.value)}>
                {options?.map(item => <option value={item.value} key={item.value}>{item.label}</option>)}
            </select>
            {dateFiltersOptionsValueArray?.includes(child_selectedFilterDdl) ? (
                <div className="range-picker-filter position-relative">
                    <MuiDatepicker
                        id="start_date"
                        name="start_date"
                        label="From"
                        value={child_startDate}
                        format="MM-DD-YYYY"
                        onChange={value => {
                            child_setStartDate(moment(value));
                        }}
                        searchFunction={() => {
                            if (!child_endDate) handleSearch({"startDate": child_startDate});
                            else handleSearch();
                        }}
                        renderInput={params => <TextField {...params} />}
                        className="custom-daterange custom-daterange-start"
                        maxDate={moment(new Date())}
                    />
                    {child_startDate && (
                        <IconButton
                            sx={{
                                p: 0,
                                position: "absolute",
                                top: "10px",
                                right: "122px",
                                zIndex: 99,
                                "@media (max-width: 565px)": {
                                    display: "none"
                                }
                            }}
                            onClick={() => {
                                child_setStartDate(null);
                                if(!child_endDate) handleSearch({startDate: "", endDate: ""})
                            }}
                        >
                            <ClearIcon
                                sx={{
                                    fontSize: "16px"
                                }}
                            />
                        </IconButton>
                    )}
                    <MuiDatepicker
                        id="end_date"
                        name="end_date"
                        label="To"
                        value={child_endDate}
                        format="MM-DD-YYYY"
                        onChange={value => {
                            child_setEndDate(moment(value));
                        }}
                        searchFunction={() => {
                            if (!child_startDate) handleSearch({"endDate": child_startDate});
                            else handleSearch();
                        }}
                        renderInput={params => <TextField {...params} />}
                        className="custom-daterange custom-daterange-end"
                        minDate={child_startDate}
                        maxDate={moment(new Date())}
                    />
                    {child_endDate && (
                        <IconButton
                            sx={{
                                p: 0,
                                position: "absolute",
                                top: "10px",
                                right: "0",
                                zIndex: 99,
                                "@media (max-width: 565px)": {
                                    display: "none"
                                }
                            }}
                            onClick={() => {
                                child_setEndDate(null);

                                // If startDate is not selected by user it will filter for that single day (endDate) but wont reflect on frontend
                                if(!child_startDate) handleSearch({startDate: "", endDate: ""})
                            }}
                        >
                            <ClearIcon
                                sx={{
                                    fontSize: "16px"
                                }}
                            />
                        </IconButton>
                    )}
                </div>
            ) : dropdownArray?.includes(child_selectedFilterDdl) ? (
                <select
                    key={child_selectedFilterDdl}
                    className="search-field-dropdown"
                    value={child_dropdownValue}
                    onChange={(e) => child_setDropdownValue(e.target.value)}
                >
                    <option value={defaultOption?.value} disabled>{defaultOption?.label}</option>
                    {dropdownOptions[child_selectedFilterDdl]?.map(item => <option value={item.value} key={`${child_selectedFilterDdl}-${item.value}`}>{item.label}</option>)}
                </select>
            ) : (
                <div className="search-field-wrapper position-relative" style={{display: "flex", alignItems: "center", width: "100%", maxWidth: "240px", height: "100%"}}>
                <input
                    type="search"
                    className="search-field search-field-no-native-clear"
                    placeholder="Search"
                    value={child_searchedText}
                    onChange={(e) => {
                        const val = e.target.value;
                        child_setSearchedText(val);
                        if (val === "") {
                            onSearch({
                                value: "",
                                startDate: "",
                                endDate: "",
                                searchedText: "",
                                dropdownValue: ""
                            });
                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            if (child_searchedText) handleSearch();
                            else onSearch({
                                value: "",
                                startDate: "",
                                endDate: "",
                                searchedText: "",
                                dropdownValue: ""
                            })
                        }
                    }}
                />
                {child_searchedText && (
                    <IconButton
                        aria-label="Clear search"
                        sx={{p: 0, position: "absolute", right: "6px", zIndex: 99}}
                        onClick={resetSearch}
                    >
                        <ClearIcon sx={{fontSize: "16px"}} />
                    </IconButton>
                )}
                </div>
            )}
            {!dropdownArray?.includes(child_selectedFilterDdl) && (
                <div className="search-btn-area">
                    <IconButton
                        className="search-btn"
                        onClick={() => {
                            if (dateFiltersOptionsValueArray?.includes(child_selectedFilterDdl)) {
                                if (!child_endDate && child_startDate) handleSearch({"startDate": child_startDate});
                                else if (child_endDate && !child_startDate) handleSearch({"endDate": child_endDate});
                                else handleSearch()
                            }
                            else if (child_searchedText) handleSearch();
                            else onSearch({
                                value: "",
                                startDate: "",
                                endDate: "",
                                searchedText: "",
                                dropdownValue: ""
                            })
                        }}
                    >
                        <SearchIcon />
                    </IconButton>
                </div>
            )}
        </div>
    );
};

export default FormSearchFilter;